export const MAX_NUMBER_OF_BOARDS = 10; // Should be in sync with MaxNumberOfBoards on server
export const MILLISECONDS_OF_ERROR_BEFORE_SHOWING_ERROR_MESSAGE = 60 * 1000;
export const MILLISECONDS_OF_MAXIMUM_EXPECTED_LATENCY = (20 + 1 + 1) * 1000; // Based on server ResourceMaxUpdateTime + 1 second for delay + 1 second for network latency
export const MILLISECONDS_BETWEEN_ALIVE_MESSAGES = 60 * 1000; // Needs to be synced with SecondsBetweenAliveMessages for server
export const MILLISECONDS_BETWEEN_EVENT_SOURCE_RECONNECTION_ATTEMPTS =
  60 * 1000;
export const MILLISECONDS_OF_MAX_EXPECTED_SERVER_STARTUP_TIME = 30 * 1000;
export const MILLISECONDS_BETWEEN_DEPARTURES_OR_ARRIVALS_PAGE_CHANGE =
  10 * 1000;
export const HORIZONTAL_BOARD_MINIMUM_ASPECT_RATIO = 16 / 10;

export const MINIMUM_TIME_IN_MILLISECONDS_TO_READ_TEXT = 5 * 1000;
export const CHARACTERS_READ_PER_SECOND = 20;
export const SCROLL_TIME_IN_MILLISECONDS = 1 * 1000;
export const TRAFFIC_SITUATION_MINIMUM_NUMBER_OF_CHARACTERS = 40;
export const PAGINATION_TIME_IN_MILLISECONDS = 0.5 * 1000;

// Default values should be synced with backend defaults
export const DEPARTURE_SORTING_DEFAULT = 'alphabetical';
export const DEPARTURE_PAGING_DEFAULT = true;
export const DEPARTURE_TIME_FORMAT_DEFAULT = 'countdown';
export const DEPARTURES_TIME_SPAN_DEFAULT = 'hour';
export const ARRIVAL_SORTING_DEFAULT = 'time';
export const ARRIVAL_PAGING_DEFAULT = false;
export const ARRIVAL_TIME_FORMAT_DEFAULT = 'countdown';
export const SHOW_PLATFORMS_IN_HEADER_DEFAULT = true;
export const VEHICLE_BOARD_DEPARTURE_SORTING_DEFAULT = 'time';
export const VEHICLE_BOARD_DEPARTURE_PAGING_DEFAULT = true;
export const VEHICLE_BOARD_DEPARTURE_TIME_FORMAT_DEFAULT = 'countdown';
export const VEHICLE_BOARD_DEPARTURES_TIME_SPAN_DEFAULT = 'hour';
export const VEHICLE_BOARD_MAX_CONNECTION_PAGES_BEFORE_CHANGING = 2;

export const MINUTES_BETWEEN_REPEATED_ANNOUNCEMENT_VOICE = 3;
export const DEPARTURE_ANNOUNCEMENT_LIFETIME_IN_MILLISECONDS = 60 * 1000;
export const VOICED_STOP_HEADER_PRIORITY = 1;
export const VOICED_DEPARTURES_PRIORITY = 2;
export const VOICED_MESSAGE_PRIORITY = 2;
export const VOICED_TRAFFIC_SITUATIONS_PRIORITY = 3;
export const BOARD_ID_PRIORITY = 10; // Multiplier for board id to make sure board information is grouped

export const MILLISECONDS_BEFORE_JOURNEY_REAL_TIME_DATA_IS_TOO_OLD =
  2 * 60 * 1000;
